export default "__VITE_ASSET__BsRbuL82__"